import React from 'react';
import { AlertObject, AlertType } from '../../../../../../components/Alert';
import { CommentInput } from '../../CommentInput';
import { ApplicationFeed } from '../../../../../../entities/ApplicationFeed';
import { ApplicationFeedComment } from '../../../../../../entities/ApplicationFeedComment';
import { User } from '../../../../../../entities/User';

interface PropTypes {
  applicationFeed: ApplicationFeed;
  comment: ApplicationFeedComment;
  currentUser: User;
  isEditing: boolean;
  reloadFeed: () => void;
  setAlert: (data: AlertObject) => void;
  setIsEditing: (state: boolean) => void;
}

export function EditComment(props: PropTypes) {
  const handleCommentInputClose = (state: boolean) => {
    props.setIsEditing(false);

    if (state === true) {
      props.reloadFeed();

      props.setAlert({
        type: AlertType.Success,
        message: 'The comment was successfully saved.',
      });
    } else if (state === false) {
      props.setAlert({
        type: AlertType.Danger,
        message: 'The comment could not be saved successfully.',
      });
    }
  };

  return (
    <>
      {props.isEditing && (
        <div className='mt-4'>
          <CommentInput
            entry={props.applicationFeed}
            currentUser={props.currentUser}
            onClose={handleCommentInputClose}
            value={props.comment}
          />
        </div>
      )}
    </>
  );
}
